import { VStack } from '@chakra-ui/react';
import React from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';
import { Agreements } from './Agreements';
import { CashFlow } from './CashFlow';
import { LegalLibrary } from './LegalLibrary';
import { Statements } from './Statements';
import { TaxDocuments } from './TaxDocuments';

export const DocumentsPage: React.FC = () => {
  return (
    <UI>
      <VStack width="full" gap="20px" alignItems={'flex-start'}>
        <VStack width="full" gap="10px">
          <TaxDocuments />
          <CashFlow />
          <Agreements />
          <LegalLibrary />
          <Statements />
        </VStack>
      </VStack>
    </UI>
  );
};
